/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import Center from './Center';

/**
 * The CompanyForm model module.
 * @module model/CompanyForm
 * @version 1.0.0
 */
class CompanyForm {
    /**
     * Constructs a new <code>CompanyForm</code>.
     * @alias module:model/CompanyForm
     * @param name {String} Nombre de la empresa (obligatorio)
     * @param taxId {String} CIF/NIF (obligatorio)
     * @param companyType {module:model/CompanyForm.CompanyTypeEnum} Tipo de empresa (obligatorio)
     * @param phone {String} Teléfono (obligatorio)
     * @param address {module:model/Address} 
     * @param center {module:model/Center} 
     */
    constructor(name, taxId, companyType, phone, address, center) { 
        
        CompanyForm.initialize(this, name, taxId, companyType, phone, address, center);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, taxId, companyType, phone, address, center) { 
        obj['name'] = name;
        obj['tax_id'] = taxId;
        obj['company_type'] = companyType;
        obj['phone'] = phone;
        obj['address'] = address;
        obj['center'] = center;
    }

    /**
     * Constructs a <code>CompanyForm</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompanyForm} obj Optional instance to populate.
     * @return {module:model/CompanyForm} The populated <code>CompanyForm</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyForm();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('tax_id')) {
                obj['tax_id'] = ApiClient.convertToType(data['tax_id'], 'String');
            }
            if (data.hasOwnProperty('company_type')) {
                obj['company_type'] = ApiClient.convertToType(data['company_type'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
            if (data.hasOwnProperty('fax')) {
                obj['fax'] = ApiClient.convertToType(data['fax'], 'String');
            }
            if (data.hasOwnProperty('monday')) {
                obj['monday'] = ApiClient.convertToType(data['monday'], 'String');
            }
            if (data.hasOwnProperty('tuesday')) {
                obj['tuesday'] = ApiClient.convertToType(data['tuesday'], 'String');
            }
            if (data.hasOwnProperty('wednesday')) {
                obj['wednesday'] = ApiClient.convertToType(data['wednesday'], 'String');
            }
            if (data.hasOwnProperty('thursday')) {
                obj['thursday'] = ApiClient.convertToType(data['thursday'], 'String');
            }
            if (data.hasOwnProperty('friday')) {
                obj['friday'] = ApiClient.convertToType(data['friday'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = Address.constructFromObject(data['address']);
            }
            if (data.hasOwnProperty('center')) {
                obj['center'] = Center.constructFromObject(data['center']);
            }
        }
        return obj;
    }


}

/**
 * Nombre de la empresa (obligatorio)
 * @member {String} name
 */
CompanyForm.prototype['name'] = undefined;

/**
 * CIF/NIF (obligatorio)
 * @member {String} tax_id
 */
CompanyForm.prototype['tax_id'] = undefined;

/**
 * Tipo de empresa (obligatorio)
 * @member {module:model/CompanyForm.CompanyTypeEnum} company_type
 */
CompanyForm.prototype['company_type'] = undefined;

/**
 * Teléfono (obligatorio)
 * @member {String} phone
 */
CompanyForm.prototype['phone'] = undefined;

/**
 * Fax (opcional)
 * @member {String} fax
 */
CompanyForm.prototype['fax'] = undefined;

/**
 * Horario lunes (opcional, al menos un día requerido)
 * @member {String} monday
 */
CompanyForm.prototype['monday'] = undefined;

/**
 * Horario martes (opcional)
 * @member {String} tuesday
 */
CompanyForm.prototype['tuesday'] = undefined;

/**
 * Horario miércoles (opcional)
 * @member {String} wednesday
 */
CompanyForm.prototype['wednesday'] = undefined;

/**
 * Horario jueves (opcional)
 * @member {String} thursday
 */
CompanyForm.prototype['thursday'] = undefined;

/**
 * Horario viernes (opcional)
 * @member {String} friday
 */
CompanyForm.prototype['friday'] = undefined;

/**
 * @member {module:model/Address} address
 */
CompanyForm.prototype['address'] = undefined;

/**
 * @member {module:model/Center} center
 */
CompanyForm.prototype['center'] = undefined;





/**
 * Allowed values for the <code>company_type</code> property.
 * @enum {String}
 * @readonly
 */
CompanyForm['CompanyTypeEnum'] = {

    /**
     * value: "ind"
     * @const
     */
    "ind": "ind",

    /**
     * value: "micro"
     * @const
     */
    "micro": "micro",

    /**
     * value: "peq"
     * @const
     */
    "peq": "peq",

    /**
     * value: "med"
     * @const
     */
    "med": "med",

    /**
     * value: "gran"
     * @const
     */
    "gran": "gran",

    /**
     * value: "fund"
     * @const
     */
    "fund": "fund",

    /**
     * value: "pub"
     * @const
     */
    "pub": "pub"
};



export default CompanyForm;

